var vms = vms || {};
var vRptID, vRptCode, vRptParams, vRptTabPopup, vRptFilename, vRptType, vRptTitlename, vRptConfirm, vRptAlert = '';
var vRptRun = 'Yes';
vms.report = {
    run: function (pRptCode,pRptParams,pRptType,pRptTabPopup,pRptFilename,pRptTitlename) {
		console.log(pRptCode);
		vRptCode = pRptCode;
		/*Get Report Parameters*/
		if (pRptType == undefined) {
			vms.report.get(pRptCode);
		}
		else {
			vRptParams = pRptParams;
			vRptType = pRptType;
		}
		if (vRptAlert !== '') {
			alert(vRptAlert);
		}
		else {
			if(pRptFilename !== undefined) {
				vRptFilename = pRptFilename;
			}
			if(pRptTitlename !== undefined) {
				vRptTitlename = pRptTitlename;
			}
			if(pRptTabPopup !== undefined) {
				vRptTabPopup = pRptTabPopup;
			}
			if (vRptRun == 'Yes') {
				apex.server.process("reportRun", {
					x01: vRptCode,
					x02: vRptParams,
					x03: vRptType,
					x04: vRptFilename,
					x05: vRptTitlename
				}, {
					dataType: "text",
					success: function (d) {
						console.log(d);
						if (vRptType == 'pdf') {
							if (vRptTabPopup == 'TAB') {
								window.open(d);
							}
							if (vRptTabPopup == 'POPUP') {
								vms.util.popup(d, 960, 600);
							}
						}
						if (vRptType == 'gen') {
							window.location.href = d;
							//vms.load.remove();
						}
					}
				});
			}
			else if (vRptRun !== 'Yes') {
				alert(vRptRun);
			}
		}
	},
    run2: function (pRcode, pParams, pType, pFilename, pRtype, pTitlename) {
		var day = new Date;
		if (pRtype == 'pdf') {			
			apex.server.process("reportRun", {
				x01: pRcode,
				x02: pParams,
				x03: pRtype,
				x04: pFilename,
				x05: pTitlename
			}, {
				dataType: "text",
				success: function (d) {
					if (pType == 'TAB') {
						window.open(d);
					}
					if (pType == 'POPUP') {
						popUp2(d, 960, 600);
					}
				}
			});
		}
		if (pRtype == 'gen') {
			pageLink(235, 'P235_RCODE,P235_PAR,P235_RTYPE', pRcode + "," + pParams + "," + pRtype, function cb(res) {
				if (res.indexOf("f?p") == 0) {
					eval(vms.util.popup(res, 500, 200));
				}
				else {
					eval(res);
				}
			});
		}
	},
    get: function (pRptCode) {
		var vPageId = $v('P333_PAGE_ID');
		var vReportType, vProfileId, vProfileIdFol, vProfileCom = '';
		var vTitle = $v('P333_REPORT_TITLE');
		console.log('pRptCode='+pRptCode);
		if (pRptCode == 'CERT_REG') {
			if (vPageId == 369) {
				vRptParams = $v('P333_PROFILE_ID')	+ ":" +
							 $v('P333_TYPE_419')	+ ":" +
							 $v('P333_CPC_TYPE')	+ ":" +
							 $v('P333_ITEM_ID')		+ ":" +
							 $v('P333_ACL_ID')		+ ":" +
							 apex.item( "P333_CERT_TYPE_419" ).getValue();
				
			}
			else {
				vRptParams = $v('P333_PROFILE_ID')	+ ":" +
							 $v('P333_TYPE_419')	+ ":" +
							 $v('P333_CPC_TYPE')	+ ":::";
			}
			
			$v('P333_REPORT_TITLE')
			
			vRptTabPopup = 'TAB';
			vRptFilename = vTitle.substring(vTitle.length-6,0);
			vRptType = 'pdf';
			vRptTitlename = vTitle.substring(vTitle.length-6,0);
		}
		else if (pRptCode == 'QUOTA_REPORT') {
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_FISHING_SEASON_413');
			vRptType = 'gen';
		}
		else if (pRptCode == 'LOG') {
			var vCheckedLogs = [];
			var vLogs;
			var vType = $v('P333_REPORT_TYPE_481');
			$("#P333_SELECTED_LOGS_481 input[type=checkbox]:checked").each(function () { vCheckedLogs.push(this.value); });
			vLogs = vCheckedLogs.join(";");
			
			if (vType == 'D') {
				vRptParams = 	$v('P333_LOG_TYPE') + "~" +
								$v('P333_PROFILE_ID') + "~ALL~" + 
								vLogs + "~" +
								$v('P333_PASSAGE_PLAN_ID_481');
			}
			else {
				vRptParams = 	$v('P333_LOG_TYPE') + "~" +
								$v('P333_PROFILE_ID');
				vRptCode = 'LOG_TEMPLATE';
			}
			vRptType = 'gen';
		}
		else if (pRptCode == 'FISH_REPORTS' || pRptCode == 'CATCH_SUMMARY' || pRptCode == 'DAILY_HAIL2' || pRptCode == 'QUOTA_REPORT') {
			vReportType = $v('P333_REPORT_TYPE_413');
			vProfileId = $v('P333_PROFILE_ID');
			vProfileIdFol = $v('P333_PROFILE_ID_FOL');
			//alert(pRptCode+"-"+vReportType);
			if (vReportType == 'QS') {
				vRptParams = vProfileId	+ "~" +
							 $v('P333_FISHING_SEASON_413');
				vRptType = 'gen';
			}
			else if (vReportType == 'DH') {
				vRptParams = $v('P333_CATCH_ID_409')	+ "~" +
							 vProfileIdFol;
				vRptTabPopup = 'TAB';
				vRptFilename = '';
				vRptType = 'pdf';
				vRptTitlename = '';				
			}
			else if (vReportType == 'CS') {
				vRptParams = $v('P333_VOYAGE_ID_410')	+ "~" +
							 $v('P333_PROFILE_ID_VSL_410');
				vRptType = 'gen';
				
			}			
		}
		else if (pRptCode == 'PLANNED_READINESS') {
			
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_START_DATE_423')	+ "~" +
						 $v('P333_END_DATE_423')	+ "~" +
						 $v('P333_SHOW_BY_423');
			vRptType = 'gen';
		}
		else if (pRptCode == 'VESSEL_PLANNING') {
			
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_START_DATE_423')	+ "~" +
						 $v('P333_END_DATE_423');
			vRptType = 'gen';
		}
		else if (pRptCode == 'AUDIT_PLANNING') {
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_START_DATE_433')	+ "~" +
						 $v('P333_END_DATE_433');
			vRptType = 'gen';
		}
		else if (pRptCode == 'VESSEL_SCHEDULE' || pRptCode == 'AUDIT_SCHEDULE') {
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_YEAR_426');
			vRptType = 'gen';			
		}
		else if (pRptCode == 'VESSEL_PLANNING') {
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_YEAR_424');
			vRptType = 'gen';
		}
		else if (pRptCode == 'CHECKLIST_TEMPLATES') {
			var vVesselId = $("#P333_VESSEL_ID_486").select2('val');
			if (vVesselId) {
				vRptParams = vVesselId	+ "~" +
							 $("#P333_CHECKLIST_TYPE_486").select2('val')	+ "~" +
							 document.querySelector('input[name="P333_STATUS_486"]:checked').value;
				vRptType = 'gen';
			}	
			else {
				vRptAlert = 'Vessel must be chosen.';
			}
		}
		else if (pRptCode == 'TRIP_CREW') {
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $('#P333_VESSEL_ID_496').select2('val')	+ "~" +
						 $("#P333_VOYAGE_IDS_496").select2('val').join(";");
			vRptType = 'gen';
		}
		else if (pRptCode == 'PM_EXECUTED_WO') {			
			vRptParams = $v('P333_PROFILE_ID')	+ "~" +
						 $v('P333_PROJECT_ID')+ "~" +							 
						 $v('P333_MASTER_ITEM_ID')+ "~" +
						 $v('P333_DATE_FROM_541')+ "~" +
						 $v('P333_DATE_TO_541');
			console.log(vRptParams);
			vRptType = 'gen';
			
		}
		else if (pRptCode == 'COMPONENT_LIST' || pRptCode == 'SCHEDULED_JOBS_LIST') {
			//Component Type
			var vClassRelated, vCritical = '';			
			if (document.getElementById('P333_COMPONENT_TYPE_511_0').checked){
				vClassRelated = 'Y';
			} else {
				vClassRelated = 'N';
			}			
			if (document.getElementById('P333_COMPONENT_TYPE_511_1').checked){
				vCritical = 'Y';
			} else {
				vCritical = 'N';
			}
			// Code
			var vCode = JSON.stringify(apex.item( "P333_CODE_511" ).getValue());
			const vCodes = JSON.parse(vCode);
			// Name
			const cNames = JSON.parse(JSON.stringify(apex.item( "P333_NAME_511" ).getValue()));
			var vNames = [];
			for (var i in cNames) {
				console.log(vNames.push(cNames[i].replace(/^\s+|\s+$/gm, '')));
			}
			// Class
			const cClass = JSON.parse(JSON.stringify(apex.item( "P333_CLASS_511" ).getValue()));
			var vClass = [];
			for (var i in cClass) {
				console.log(vClass.push(cClass[i].replace(/^\s+|\s+$/gm, '')));
			}
			// Serial Number
			const cSN = JSON.parse(JSON.stringify(apex.item( "P333_SERIAL_NUMBER_511" ).getValue()));
			var vSN = [];
			for (var i in cSN) {
				console.log(vSN.push(cSN[i].replace(/^\s+|\s+$/gm, '')));
			}
			// Manufacturer
			const cMan = JSON.parse(JSON.stringify(apex.item( "P333_MANUFACTURER_511" ).getValue()));
			var vMan = [];
			for (var i in cMan) {
				console.log(vMan.push(cMan[i].replace(/^\s+|\s+$/gm, '')));
			}
			// Supplier
			const cSup = JSON.parse(JSON.stringify(apex.item( "P333_SUPPLIER_511" ).getValue()));
			var vSup = [];
			for (var i in cSup) {
				console.log(vSup.push(cSup[i].replace(/^\s+|\s+$/gm, '')));
			}
			// Service Provider
			const cSer = JSON.parse(JSON.stringify(apex.item( "P333_SERVICE_PROVIDER_511" ).getValue()));
			var vSer = [];
			for (var i in cSer) {
				console.log(vSer.push(cSer[i].replace(/^\s+|\s+$/gm, '')));
			}
			// Group
			const cGrp = JSON.parse(JSON.stringify(apex.item( "P333_GROUP_511" ).getValue()));
			var vGrp = [];
			for (var i in cGrp) {
				console.log(vGrp.push(cGrp[i].replace(/^\s+|\s+$/gm, '')));
			}
			if (pRptCode == 'SCHEDULED_JOBS_LIST') {
				// Code
				const cCodeSJ = JSON.parse(JSON.stringify(apex.item( "P333_CODE_516" ).getValue()));
				var vCodesSJ = [];
				for (var i in cCodeSJ) {
					console.log(vCodesSJ.push(cCodeSJ[i].replace(/^\s+|\s+$/gm, '')));
				}
				// Title
				const cTitleSJ = JSON.parse(JSON.stringify(apex.item( "P333_NAME_516" ).getValue()));
				var vTitlesSJ = [];
				for (var i in cTitleSJ) {
					console.log(vTitlesSJ.push(cTitleSJ[i].replace(/^\s+|\s+$/gm, '')));
				}
				// Assigned to
				const cAssignedSJ = JSON.parse(JSON.stringify(apex.item( "P333_ASSIGNED_TO_516" ).getValue()));
				var vAssignedSJ = [];
				for (var i in cAssignedSJ) {
					console.log(vAssignedSJ.push(cAssignedSJ[i].replace(/^\s+|\s+$/gm, '')));
				}
				// Interval
				const cIntervalSJ = JSON.parse(JSON.stringify(apex.item( "P333_INTERVAL_516" ).getValue()));
				var vIntervalSJ = [];
				for (var i in cIntervalSJ) {
					console.log(vIntervalSJ.push(cIntervalSJ[i].replace(/^\s+|\s+$/gm, '')));
				}
			}
			if (pRptCode == 'COMPONENT_LIST') {
				vRptParams = $v('P333_PROFILE_ID')	+ "~" +
							 vClassRelated + "|" + vCritical + "~" +
							 vCodes.join('|').replace(/\s/g, '') + "~" +
							 vNames.join('|') + "~" +
							 vClass.join('|') + "~" +
							 vSN.join('|') + "~" +
							 vMan.join(';') + "~" +
							 vSup.join('|') + "~" +
							 vSer.join('|') + "~" +
							 vGrp.join('|');
			}
			if (pRptCode == 'SCHEDULED_JOBS_LIST') {
				vRptParams = $v('P333_PROFILE_ID')	+ "~" +
							 vClassRelated + "|" + vCritical + "~" +
							 vCodes.join('|').replace(/\s/g, '') + "~" +
							 vNames.join('|') + "~" +
							 vClass.join('|') + "~" +
							 vSN.join('|') + "~" +
							 vMan.join(';') + "~" +
							 vSup.join('|') + "~" +
							 vSer.join('|') + "~" +
							 vGrp.join('|') + "~" +
							 vCodesSJ.join('|') + "~" +
							 vTitlesSJ.join('|') + "~" +
							 vAssignedSJ.join('|') + "~" +
							 vIntervalSJ.join('|') + "~" +
							 $v('P333_DATE_FROM_516')+ "~" +
							 $v('P333_DATE_TO_516')+ "~" +
							 '';
			}
			vRptType = 'gen';
		}
    },
	getID: function (pRptCode) {
		apex.server.process('reportID', {
			x01: pRptCode
		}, {
				type: "GET",
				dataType: "html",
				success: function (ret) {
					vRptID = ret;
				}
			});
    },
	getCode: function (pRcode, pProfileId) {		
		apex.server.process("getReportCode", {
			x01: pRcode,
			x02: pProfileId
		}, {
				dataType: "text",
				success: function (ret) {
					//alert(ret);
					return ret;
				}
			});
	}
};

/* TODO cleanup after UT*/
var reportRun = vms.report.run2;